import React from 'react';
import { useCurator } from '@noths/curator-web';
import dynamic from 'next/dynamic';

import { isProd } from 'src/environment';
import type { ContentPageProps } from 'src/types/PageProps';

const Curator = dynamic(
  () =>
    import('@noths/curator-web').then(async (m) => {
      m.configureCurator({
        env: isProd() ? 'production' : 'qa',
      });
      return m.Curator;
    }),
  { ssr: false },
);

interface CuratorWrapperProps {
  siteChromeContent?: ContentPageProps['siteChromeContent'];
}

export const CuratorWrapper = ({ siteChromeContent }: CuratorWrapperProps) => {
  const showCurator = siteChromeContent?.enableCurator ?? false;
  const { handleToggle, isCuratorOpen, redirectToPDP } = useCurator();

  if (!showCurator) {
    return null;
  }

  return (
    <Curator
      isOpen={isCuratorOpen}
      onProductClick={redirectToPDP}
      onToggle={handleToggle}
      showFavourties
    />
  );
};
